import { Typography } from "@lyfegen-platform/react-common";
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, useTheme } from "@material-ui/core";
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import { useState } from "react";
import useStyles from "../use-styles";
import { Record } from "./RecordsCard";
import { ITreatmentSummaryDetails, TreatmentSummaryDetails } from "./TreatmentSummaryDetails";

interface IProps {
	title: string;
	treatmentSummary?: ITreatmentSummaryDetails | null | undefined;
	currencyName: string | undefined;
	records: Array<Record>;
}

const TreatmentSummary = (props: IProps) => {
	const { bodyItemHeader, collapseTitle } = useStyles();
	const [isExpanded, setIsExpanded] = useState(true);
	const { palette } = useTheme();

	function toggleExpanded() {
		setIsExpanded(!isExpanded);
	}

	return (
		<Accordion
			defaultExpanded
			onChange={toggleExpanded}
			expanded={true}
			TransitionProps={{ unmountOnExit: true }}
			style={{ borderRadius: "0px 0px 12px 12px" }}
			elevation={0}
		>
			<AccordionSummary
				className={bodyItemHeader}
				style={{ display: "flex", flexDirection: "row-reverse" }}
				expandIcon={isExpanded ? <ExpandMoreIcon color={"inherit"} /> : <ExpandLessIcon color={"inherit"} />}
				aria-controls={props.title}
				id={props.title}
			>
				<Typography className={collapseTitle} type={"h5"} color={"textSecondary"}>
					{props.title}
				</Typography>
			</AccordionSummary>
			<Box justifyContent="space-between" width="100%" display="flex" alignItems="center" pb={2}>
				<Divider style={{ flexGrow: 1, backgroundColor: palette.tableDivider.main }} />
			</Box>
			<AccordionDetails>
				<TreatmentSummaryDetails {...props.treatmentSummary} isCollapsed={!isExpanded} currencyName={props.currencyName || ""} records={props.records || []} />
			</AccordionDetails>
		</Accordion>
	);
};

export default TreatmentSummary;
